import { cloneElement, ReactElement } from 'react';

export function Repeat({ times, children }: { times: number; children: ReactElement }) {
  const result = [];
  for (let i = 0; i < times; i++) {
    result.push(cloneElement(children, { key: i }));
  }
  return <>{result}</>;
}
